/**------------------------------------------------------
 * Favorites constants
 */
export enum EnumFavoriteSorting {
	Tag 		= 'tag',
	Date		= 'date',
	Platform	= 'platform',
	Title		= 'title'
}
